import {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucidePhone,
  lucideRefreshCw,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideStar,
  lucideUserCheck,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideUser,
} from '@ng-icons/lucide';

export const ICONS_MAP = {
  lucideArrowLeft,
  lucideCalendar,
  lucideCamera,
  lucideCheck,
  lucideChevronDown,
  lucideCircleAlert,
  lucideCircleCheck,
  lucideEye,
  lucideEyeOff,
  lucideFileText,
  lucideGlobe,
  lucideHandCoins,
  lucideInfo,
  lucideKeyRound,
  lucideLink,
  lucideLockKeyhole,
  lucideMail,
  lucideMailCheck,
  lucideMapPin,
  lucideMessageCircle,
  lucideMessageSquareWarning,
  lucidePhone,
  lucideRefreshCw,
  lucideShoppingBasket,
  lucideSmartphone,
  lucideStar,
  lucideUserCheck,
  lucideX,
  lucideGift,
  lucidePackageOpen,
  lucideUser,
};

type LucideIcon = keyof typeof ICONS_MAP;

export const ICONS_NAME_MAP = {
  'arrow-left': 'lucideArrowLeft',
  calendar: 'lucideCalendar',
  camera: 'lucideCamera',
  check: 'lucideCheck',
  'chevron-down': 'lucideChevronDown',
  'circle-alert': 'lucideCircleAlert',
  'circle-check': 'lucideCircleCheck',
  email: 'lucideMail',
  'eye-off': 'lucideEyeOff',
  eye: 'lucideEye',
  'file-text': 'lucideFileText',
  info: 'lucideInfo',
  'key-round': 'lucideKeyRound',
  'link': 'lucideLink',
  'lock-keyhole': 'lucideLockKeyhole',
  'mail-check': 'lucideMailCheck',
  'map-pin': 'lucideMapPin',
  'message-important': 'lucideMessageSquareWarning',
  'messages': 'lucideMessageCircle',
  phone: 'lucidePhone',
  'refresh-cw': 'lucideRefreshCw',
  'shopping-basket': 'lucideShoppingBasket',
  'smartphone': 'lucideSmartphone',
  star: 'lucideStar',
  'user-check': 'lucideUserCheck',
  website: 'lucideGlobe',
  x: 'lucideX',
  'hand-coins': 'lucideHandCoins',
  gift: 'lucideGift',
  'package-open': 'lucidePackageOpen',
  user: 'lucideUser',
} satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof ICONS_NAME_MAP;
